/* NB Mobile fixed buy rail (draft). One click delegates to Shopify's real
   product form so quantity, selected variant, cart drawer and app hooks survive. */
(function () {
  'use strict';
  function init() {
    document.querySelectorAll('[data-nb27-fixed-buy]:not([data-nb27-ready])').forEach(function (rail) {
      const sectionId = rail.getAttribute('data-section');
      if (!sectionId) return;
      const mainForm = document.getElementById('product-form-' + sectionId);
      const originalButton = mainForm && mainForm.querySelector('button[name="add"]');
      const originalButtons = originalButton && originalButton.closest('.product-form__buttons');
      if (!originalButtons || !originalButton) return;

      rail.setAttribute('data-nb27-ready', 'true');
      // Body-level fixed position prevents ancestor transforms, clipping and
      // stacking contexts from hiding the bar beneath the product section.
      if (rail.parentElement !== document.body) document.body.appendChild(rail);
      const add = rail.querySelector('[data-nb27-add]');
      const price = rail.querySelector('[data-nb27-price]');
      const label = rail.querySelector('[data-nb27-button-label]');
      const originalLabel = originalButton.querySelector('span');
      const priceSource = document.getElementById('price-top-' + sectionId);
      const initialPriceMarkup = price.innerHTML;
      let ticking = false;

      function sync() {
        add.disabled = !!originalButton.disabled || originalButton.getAttribute('aria-disabled') === 'true';
        if (originalLabel && label) label.textContent = originalLabel.textContent.trim();
        if (priceSource && price) {
          const pricing = priceSource.querySelector('.price');
          if (pricing) {
            const clone = pricing.cloneNode(true);
            clone.removeAttribute('id');
            clone.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
            const markup = clone.outerHTML;
            if (price.innerHTML !== markup) price.innerHTML = markup;
          } else if (!price.innerHTML.trim()) {
            price.innerHTML = initialPriceMarkup;
          }
        }
        const gallery = document.getElementById('MediaGallery-' + sectionId);
        const active = gallery && (gallery.querySelector('.product__media-item.is-active img') || gallery.querySelector('.product__media-item img'));
        const image = rail.querySelector('.nb27-fixed-buybar__image img');
        if (active && image) {
          const src = active.currentSrc || active.src;
          if (src && image.src !== src) {
            image.removeAttribute('srcset');
            image.removeAttribute('sizes');
            image.src = src;
          }
        }
      }

      function update() {
        ticking = false;
        if (!rail.isConnected || !originalButtons.isConnected) return;
        const bounds = originalButtons.getBoundingClientRect();
        const show = window.scrollY > 120 && bounds.bottom < 0;
        rail.classList.toggle('is-visible', show);
        rail.setAttribute('aria-hidden', show ? 'false' : 'true');
        rail.inert = !show;
        if (show) sync();
      }

      function schedule() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      }

      add.addEventListener('click', function () {
        sync();
        if (originalButton.isConnected && !originalButton.disabled) {
          originalButton.click();
        } else if (originalButton.isConnected) {
          originalButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });

      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      document.addEventListener('afterVariantChanged', function (event) {
        if (event.detail && event.detail.sectionId && event.detail.sectionId !== sectionId) return;
        window.requestAnimationFrame(function () { sync(); schedule(); });
      });
      const obs = new MutationObserver(function () { sync(); });
      if (priceSource) obs.observe(priceSource, { childList: true, subtree: true, characterData: true });
      const buttonObs = new MutationObserver(function () { sync(); });
      buttonObs.observe(originalButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      sync();
      schedule();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();